import { createSlice } from "@reduxjs/toolkit";
import { addUserAction } from "../actions/addUserAction";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const addUserSlice = createSlice({
  name: "addUser",
  initialState,
  reducers: {
    clearaddUserState: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addUserAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addUserAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addUserAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearaddUserState } = addUserSlice.actions;
export default addUserSlice.reducer;
